import React from 'react';
import { IConfiguration } from '../../configuration';

export const ConfigurationContext = React.createContext<IConfiguration>({} as IConfiguration);
